import { Auth, initialAuth } from './auth/auth-state.model';

export interface AppState {
  auth: Auth;
}
export const INITIAL_STATE = {
  auth: initialAuth,
};
